import React from 'react';
import { setCurrentModal } from '../thunks/setCurrentModal';
import { useAppDispatch, useAppSelector } from '../app/hooks';
import { setMenuMessageModalDisplayed } from '../slices/menuMessageModalDisplayed';
import MessageModalAtom from '../components/atoms/MessageModal';

export const MESSAGE_MODAL_ID = 'MESSAGE_MODAL_ID';

const MessageModal = ({
  title,
  message,
  titleStyle,
  desktopMaxWidth = 500,
  desktopWidth = 500,
  handleClose,
}: {
  desktopMaxWidth?: number;
  desktopWidth?: number;
  title?: string;
  message?: string;
  titleStyle?: React.CSSProperties;
  handleClose?: () => void;
  closeButtonStyle?: React.CSSProperties;
}) => {
  const dispatch = useAppDispatch();
  const modalParams = useAppSelector(state => state.modalParams) as ModalDataParams;

  return (
    <MessageModalAtom
      title={title ? title : modalParams?.title}
      message={modalParams?.message ?? message}
      titleStyle={titleStyle}
      desktopMaxWidth={desktopMaxWidth}
      desktopWidth={desktopWidth}
      hideCloseButton={modalParams?.hideCloseButton}
      buttonText={modalParams?.buttonText}
      action={modalParams?.action}
      alertButtons={modalParams?.alertButtons}
      handleClose={
        modalParams?.onClose ||
        (() => {
          // eslint-disable-next-line
          handleClose && handleClose();
          dispatch(setMenuMessageModalDisplayed(true));
          dispatch(setCurrentModal(null));
        })
      }
    />
  );
};

export default MessageModal;
